const {
    VITE_APP_DEV_PUBLIC_URL,
    VITE_APP_OKTA_CLIENT_ID,
    VITE_APP_OKTA_ISSUER_URL,
} = import.meta.env

const config = () => {
    return {
        clientId: VITE_APP_OKTA_CLIENT_ID
            ? VITE_APP_OKTA_CLIENT_ID
            : "0oasi32h64iA9WwhU0h7",
        issuer: VITE_APP_OKTA_ISSUER_URL
            ? VITE_APP_OKTA_ISSUER_URL
            : "https://wabtec.oktapreview.com/oauth2/ausrjhvj8rcoY6A4Z0h7",
        redirectUri: `${VITE_APP_DEV_PUBLIC_URL}/callback`,
        scopes: ["openid", "profile", "email"],
        pkce: true,
        tokenManager: {
            autoRenew: true,
        },
    }
}

export default config
